import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { PagerService } from '../../services/index';
import { CookieService } from 'ngx-cookie-service';
import * as $ from 'jquery/dist/jquery.min.js';
declare var jQuery: any;

@Component({
  selector: 'app-group-list',
  templateUrl: './society-group-list.component.html',
  styleUrls: ['./society-group-list.component.css']
})
export class SocietyGroupListComponent implements OnInit {

  groupList: any = [];
  pager: any = {};
  pagedItems: any[];
  total: any;
  limit: any;
  pageNo: any;
  url: any;
  isSurveyAvailable: boolean = false;
  redirectUrl: any;
  activePageNo: number = 0;
  my_group_list = [];
  selected_group_id = null;
  selected_group_name = null;
  searchStr = null;
  group_description = null;
  constructor(private commonService: CommonService, private authService: AuthService,
    private router: Router, private validationService: ValidationService,
    private pagerService: PagerService, private cookieService: CookieService) { }

  ngOnInit() {
    this.initialiseSurvey();
    this.commonService.process();
  }

  //Search Users
  searchUser = function () {
    this.limit = 10;
    this.pageNo = 1;
    this.getAllGroupsList(this.pageNo, this.limit);
  }

  // Get Survey List
  initialiseSurvey = function () {    
		$('.navbar-brand').text('Groups');
    this.commonService.setTitle();
    this.limit = 10;
    this.pageNo = 1;

    let route = this.router.url;
    if (route.indexOf("?") !== -1) {
      var routeArr = route.split('?backUrl=');
      var decodedUri = decodeURIComponent(routeArr[1]);
      var decodedArr = decodedUri.split("&");
      var decodedPageNo = decodedArr[0].split("pageNo=");

      this.pageNo = decodedPageNo[1];
      this.activePageNo = decodedPageNo[1];
      
			var decodedSearchStr = decodedArr[1].split("searchStr=");
			this.searchStr_back = decodedSearchStr[1];
      $(".navbar-brand").text("Group Surveys");
    }

    // Get groups list
    this.getAllGroupsList(this.pageNo, this.limit);
  }

  // Get group survey list
  getAllGroupsList = function (pageNo, limit) {
            // debugger;;
    $("#search").val(this.searchStr_back ? this.searchStr_back :  $('#search').val());
    this.searchStr_back = null;
    var searchStr = $('#search').val();
    this.commonService.process();
    this.authService.getAllSocietyGroupsListinAdmin(pageNo, limit, searchStr).subscribe(data => {
      if (data.success) {
        var that =this;
        if (pageNo == this.activePageNo)
          setTimeout(function () {
            $('#page_' + that.activePageNo).addClass('active');
            if (that.activePageNo == 1)
              $('#first, #prev').addClass('disabled');
            else if (that.activePageNo == that.pager.totalPages)
              $('#next, #last').addClass('disabled');
          }, 300);
        this.groupList = data.groups;
        this.total = data.total;
        this.setPage(pageNo, true);
        this.pageNo = pageNo;
        this.redirectUrl = "pageNo=" + pageNo + "&searchStr=" + searchStr + "&groupList=1";
      }
      else {
        this.groupList = [];
        this.isSurveyAvailable = true;
      }
      this.commonService.hideProcess();
    });
  }

  // Pagination
  setPage(page: number, param) {
    this.pager = this.pagerService.getPager(this.total, page);
    $(this).parent('li').addClass('active');
    $('.pages.active a').each(function () {
      if (parseInt($(this).text()) != page)
        $(this).parent('li').removeClass('active');
    });
    if ($('#first, #prev').hasClass('disabled') && page != this.pager.totalPages && page != 1)
      $('#first, #prev').removeClass('disabled');
    if ($('#next, #last').hasClass('disabled') && page != this.pager.totalPages)
      $('#next, #last').removeClass('disabled');

    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    // get current page of items
    this.pagedItems = this.groupList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    if (!param) {
      this.getAllGroupsList(page, this.limit);
    }
  }

  // Delete selected Survey Details
  deleteSelectedGroup = function (group) {
    this.selected_group_id = group._id;
    this.selected_group_name = group.group_name;
  }

  // Delete Survey
  deleteGroup = function () {
    if (this.selected_group_id) {
      this.authService.deleteGroup(this.selected_group_id).subscribe(data => {
        if (data.success) {
          this.authService.cancelProcess();
          this.getAllGroupsList(this.pageNo, this.limit);
          jQuery.growl.notice({ title: 'Success', message: data.message });
        }
        else {
          jQuery.growl.error({ title: 'Error', message: data.error });
        }
        this.selected_group_id = null;
        this.selected_group_name = null;
      });
    }
    else {
      jQuery.growl.error({ title: 'Error', message: "Group must be selected!" });
    }
  }
  showDescription(description){
    this.group_description = description;
  }
}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/society-group-list/society-group-list.component.ts